<script>
  import Base from './Base.svelte';
</script>
<Base {...$$props} type="pie" />
